<template>
  <div class="content--sinoreg Resumo">
    <header-blue>
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <b-col sm="3"
                 class="resumeTitle">
            <icon-svg icon="nascimento"
                      class="icon--md typeIcon" />
            Nascimento
          </b-col>
          <b-col sm="9"
                 class="headerEditNascimento">
            <b-row>
              <span class="pt-3 resumo-show_title-label">
                {{ data.registro ? data.registro.pessoa.nome : '' }}
              </span>
            </b-row>
            <b-row>
              <HeaderBoxResume v-if="data.registro_id"
                               class="matricula_id"
                               :info="data.registro.pessoa.cpf | cpf"
                               text="CPF" />
              <HeaderBoxResume v-if="data.registro_id"
                               :info="data.registro.data_ocorrido | date"
                               text="Data do ocorrido" />
              <HeaderBoxResume v-if="data.registro_id"
                               :info="data.registro.data_registro | date"
                               text="Data de registro" />
              <HeaderBoxResume v-if="data.registro_id"
                               class="matricula_id"
                               :info="data.registro.matricula | maskMatricula"
                               text="Matrícula" />
            </b-row>
          </b-col>
        </b-row>
      </h4>
    </header-blue>

    <b-tabs content-class=""
            class="Resumo-border"
            align="left"
            :active-nav-item-class="errosAbas.indexOf(tab_atual + 1) != -1 ? 'Resumo--tab-active_error': 'Resumo--tab-active'">
      <b-tab active
             @click="tab_atual = 0">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(1) != -1 && tab_atual != 0}">
            Nascido
            <IconSvg v-if="errosAbas.indexOf(1) != -1"
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>
        <AbaNascido :data="data"
                    :prop-cartorio="dadosCartorio"
                    :prop-correcoes="correcoes"
                    @deleteError="deleteError"
                    @updateInfo="updateInfo"
                    @receiveError="receiveError"
                    @possuiGemeos="possuiGemeos" />
      </b-tab>

      <b-tab @click="tab_atual = 1">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(2) != -1 && tab_atual != 1}">
            Outras Informações
            <IconSvg v-if="errosAbas.indexOf(2) != -1"
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>
        <AbaOutrasInfo v-if="data.registro"
                       :data="data"
                       :prop-cartorio="dadosCartorio"
                       :prop-correcoes="correcoes"
                       :prop-flags="flags"
                       @deleteError="deleteError"
                       @updateInfo="updateInfo" />
      </b-tab>
      <b-tab @click="tab_atual = 2">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(3) != -1 && tab_atual != 2}">
            Registro
            <IconSvg v-if="errosAbas.indexOf(3) != -1"
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>
        <abaRegistro v-if="data.registro"
                     :data="data"
                     :prop-cartorio="dadosCartorio"
                     :prop-correcoes="correcoes"
                     @deleteError="deleteError"
                     @updateInfo="updateInfo" />
      </b-tab>
      <b-tab v-if="data.registro.transporte"
             @click="tab_atual = 3">
        <template v-slot:title>
          <div :class="{'nav-link_error':errosAbas.indexOf(4) != -1 && tab_atual != 3}">
            Transporte
            <IconSvg v-if="errosAbas.indexOf(4) != -1"
                     class="icon-error"
                     icon="alert" />
          </div>
        </template>
        <AbaTransporte v-if="data.registro.transporte"
                       :data="data"
                       :prop-cartorio="dadosCartorio"
                       :prop-correcoes="correcoes"
                       @updateInfo="updateInfo" />
      </b-tab>
    </b-tabs>
    <div class="cadastroNasc_footer mb-2 border-top border-dark pt-3">
      <div class="row no-gutters justify-content-between">
        <ExcluirCancelarRegistro v-if="data.registro && data.registro.registro_id"
                                 :prop-registro="data.registro"
                                 :registro-id="data.registro.registro_id"
                                 @onBlockUpdate="status => bloquearRegistro(status)" />

        <div class=" justify-content-end">
          <div class="d-inline-block">
            <b-link id="btn-cancel-registro"
                    class="btn btn-sm btn-dark"
                    :to="{ name: 'resumo_nascimento', params: { id: data.nascimento_id }}">
              Voltar
            </b-link>
          </div>

          <div v-if="data.registro && data.registro.existe_crc"
               class="d-inline-block ml-2">
            <button id="btn-submit-registro"
                    v-b-modal.modalMotivoAlteracao
                    class="btn btn-sm btn-primary"
                    type="button">
              Salvar
            </button>
          </div>
          <div v-else
               class="d-inline-block ml-2">
            <button id="btn-submit-registro"
                    class="btn btn-sm btn-primary"
                    type="button"
                    @click="verifyInputs">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <MotivoAlteracao tipo="N"
                     :tarefa-alteracao-carga="tarefaAlteracaoCarga"
                     @gravarAtualizacao="save($event)" />
  </div>
</template>

<script>

  /* components*/
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue.vue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import AbaNascido from "@/components/SofiaRei/Nascimento/Edicao/abas/AbaNascido.vue"
  import AbaOutrasInfo from "@/components/SofiaRei/Nascimento/Edicao/abas/AbaOutrasInfo.vue"
  import abaRegistro from "@/components/SofiaRei/Nascimento/Edicao/abas/abaRegistro.vue"
  import AbaTransporte from "@/components/SofiaRei/AbaTransporte.vue"
  //import PassoRegistro from "@/components/SofiaRei/Nascimento/Cadastro/passos/PassoRegistro.vue"
  import ExcluirCancelarRegistro from '@/components/SofiaRei/ExcluirCancelarRegistro'
  import MotivoAlteracao from '@/components/SofiaRei/Resumo/MotivoAlteracao.vue'

  /* services */
  import AvosService from "@/services/Registros/Nascimento/AvosService"
  import NascimentoService from "@/services/Registros/Nascimento"

  /* assets */
  import icon_nasc from "@/assets/icons/nascimento.svg?sprite"

  /* constants */
  import objSwal from '@/constants/swalValues'

  /* outros */
  import { mapGetters } from 'vuex'

  export default {
    name: "EdicaoNascimento",
    components: {
      HeaderBlue,
      HeaderBoxResume,
      AbaNascido,
      AbaOutrasInfo,
      abaRegistro,
      AbaTransporte,
      ExcluirCancelarRegistro,
      MotivoAlteracao
    },
    props: {
      propCorrecoes: {type: Object, default: () => ({})},
      propNascimento: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        data: {},
        icons: {
          icon_nasc: icon_nasc,
        },
        avosUpdate: [],
        dadosCartorio: {},
        error: false,
        tab_atual: 0,
        errosAbas: [],
        correcoes: {...this.propCorrecoes},
        registroId: null,
        flags: {},
        tarefaAlteracaoCarga: null,
        possuiGemeosCRC: false
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorio: 'auth/getCartorioObj'
      }),
    },
    watch: {
      propCorrecoes () {
        this.correcoes = {...this.propCorrecoes}
      }
    },
    async beforeMount () {
      await this.init()
    },
    mounted () {
      this.getCartorio()
      this.verifyCorrecoes().abas()
      this.controlEvent().addEvent()
    },
    methods: {
      async init () {
        let { idNasc } = this.$route.params


        try {
          loader({ text: 'Buscando dados...', active: true })
          const res = Object.values(this.propNascimento).length ? this.propNascimento : await NascimentoService.getNascimentoById(idNasc, this.$store.state.auth.cartorio_id, this.registroId)

          this.registroId = res.registro_id
          this.flags = {
            ignorar_gestacao: res.nascimentoInformacao && res.nascimentoInformacao.total_semanas_gestacao === 0,
            ignorar_consultas: res.nascimentoInformacao && res.nascimentoInformacao.total_consultas_pre_natal === 0
          }

          this.tarefaAlteracaoCarga = res.registro.tarefas.find((tarefa) => {
            return tarefa.acao === 'ALTERACAO' && tarefa.tipo === 'CARGA'
          })

          this.possuiGemeosCRC = !!res.registro.pessoa.possui_gemeos_crc

          return  this.data = { ...res }
        } catch (e) {

          if (e.response && e.response.status === 404) {
            this.$router.push('/pagina-nao-encontrada')
            loader({ text: '', active: false })
          }
          else {
            objSwal.error.title = 'Erro ao buscar dados!'
            objSwal.error.text = e.message || 'Algum problema ao acessar os dados informados.'
            loader({ text: '', active: false })
            return Swal.fire(objSwal.error)

          }
        } finally {
          loader({ text: '', active: false })
        }
      },
      setDnvMask (val) {
        let init  = val.substring(0, 2)
        let middle  = val.substring(2, 9)
        let end  = val.substring(10, 10)

        if (!val || (val.length !== 11)) return val
        return `${init}-${middle}-${end}`
      },
      async updateInfo (val) {
        if (val) {
          // Verificamos se a atualização possui deleteds
          if (val.deleteds) {
            // Veriricamos se o data possui deleteds para evitar erros de undefined
            if (!this.data.deleteds) this.data.deleteds = {}

            Object.keys(val.deleteds).forEach((key) => {
              // Verificamos se a key já foi definida no data
              if (!this.data.deleteds[key]) this.data.deleteds[key] = []

              /**
              * Verificamos cada key do deleteds da atualização e após verificar
              * se o valor não está no array correspondente damos um push
              */
              val.deleteds[key].forEach(deleted => {
                if (this.data.deleteds[key].findIndex(del => deleted == del) == -1) {
                  this.data.deleteds[key].push(deleted)
                }
              })
            })
          }
          // Mantemos o deleteds para evitar perda de dados
          this.data = { ...val, deleteds: this.data.deleteds }
        }
      },
      //Verificando campos obrigatorios
      verifyInputs () {
        this.$validator.validate().then(resp => {
          const {errors: {items}} = this.$validator
          const messages = []

          items.forEach(item => {
            switch (item.field) {
            case 'nome':
              messages.push('Informe o nome do registrado')
              break
            case 'dataNascimento':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data de nascimento') : messages.push('Data de nascimento inválida')
              break
            case 'horaNascimento':
              messages.push('Hora do nascimento inválida')
              break
            case 'decNascidoVivo':
              messages.push('Nº Declaração Nascido Vivo inválido')
              break
            case 'ordem_nascimento_registrado':
              messages.push('Informe a ordem de Nascimento do Registrado')
              break
            case 'data_registro':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data do registro') : messages.push('Data do registro inválida')
              break
            case 'registro_livro':
              messages.push('Informe o número do livro')
              break
            case 'registro_folha':
              messages.push('Informe o número da folha')
              break
            case 'registro_termo':
              messages.push('Informe o número do registro')
              break
            case 'transporte_livro':
              messages.push('Informe o número do livro do transporte')
              break
            case 'transporte_folha':
              messages.push('Informe o número da folha do transporte')
              break
            }
          })

          if (resp && !items.length) {
            this.save()

          } else {
            let invalids = document.querySelectorAll('.is-invalid')
            this.invalids(invalids)
            !!messages ? this.showErrorList(messages) : ''
          }
        })
      },
      async save ($event = null) {
        const data = $event
        try {
          let { idNasc } = this.$route.params
          loader({ text: 'Enviando dados...', active: true })
          this.$root.$emit('bv::hide::modal', 'modalMotivoAlteracao')

          if (data) {
            this.data.registro.cod_motivo_alt = data.codigo
            this.data.registro.data_averb_motivo_alt = data.dataAverb
          }

          let dnv = this.data.registro.numero_declaracao_nascido_vivo
          this.data.registro.numero_declaracao_nascido_vivo = dnv || null

          if (this.avosUpdate.length) {
            this.avosUpdate.forEach(res => {
              AvosService.updateAvo(res)
            })
          }

          this.data.registro.pessoa.possui_gemeos_crc = this.possuiGemeosCRC

          if (!this.data.registro.oficial) {
            this.data.registro.oficial = this.cartorio.nome_oficial
          }

          await NascimentoService.updateNascimento(idNasc, this.data)

          objSwal.success.title = 'Dados atualizados!'
          objSwal.success.text = ''

          return Swal.fire(objSwal.success).then(() => {
            this.$router.push({ name: 'resumo_nascimento', params: { id: this.$route.params.idNasc } })
          })
        } catch ({ response }) {
          if (response.data.message) {
            objSwal.error.title = 'Erro ao atualizar!'
            objSwal.error.text = response.data.message
          } else {
            objSwal.error.title = 'Erro ao atualizar!'
            objSwal.error.text = 'Contacte o suporte'
          }

          return Swal.fire(objSwal.error)
        }
        finally {
          loader({ text: '', active: false })
        }
      },
      invalids (list) {
        if (list.length) {
          list[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }
      },
      updateAvos (avos) {
        this.avosUpdate = avos
      },
      async getCartorio () {
        this.dadosCartorio = this.$store.getters['auth/getCartorioObj']
      },
      possuiGemeos (val) {
        this.possuiGemeosCRC = val
      },
      receiveError (error = false) {
        this.error = error
      },
      verifyCorrecoes () {
        const aba = (num) => {
          if (Object.values(this.correcoes).indexOf(num) != -1) return true
        }

        const abas = () => {
          this.errosAbas = Object.values(this.correcoes)
        }

        const campos = (name) => {
          const keys = Object.keys(this.correcoes)

          if (Array.isArray(name)) {
            const equals = name.filter(val => {
              let find = false

              keys.forEach(key => {
                if (key.match(val)) find = true
              })

              return find
            })

            if (equals.length) return true
          } else {
            let find = false

            keys.forEach(key => {
              if (key.match(name)) find = true
            })

            return find
          }
        }

        return { aba, abas, campos }
      },
      deleteError (errors) {
        errors.forEach(error => {
          delete this.correcoes[error]
          this.correcoes = {...this.correcoes}
          this.verifyCorrecoes().abas()
        })
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.nav-link')
            const btnSubmit = document.querySelector('#btn-submit-registro')
            const btnCancel = document.querySelector('#btn-cancel-registro')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })

              abas[0].focus()
            }

            if (btnSubmit) {
              btnSubmit.onkeydown = firstAba
            }

            if (btnCancel) {
              btnCancel.onkeydown = firstAba
            }
          }, 400)
        }

        const nextAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const input = document.querySelector('#nome')

          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1) {
            setTimeout(() => {
              abas[index + 1].focus()
              abas[index + 1].scrollIntoView({ block: 'center', inline: "nearest" })
            })
          } else if (index != -1 && index == abasArr.length - 1) {
            setTimeout(() => {
              input.focus()
              input.scrollIntoView({ block: 'center', inline: "nearest" })
            })
          }
        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const btnSubmit = document.querySelector('#btn-submit-registro')

          if (abas) {
            if (event.target.id == 'btn-cancel-registro' && (btnSubmit && btnSubmit.disabled) || event.target.id == 'btn-submit-registro') {
              setTimeout(() => {
                abas[0].focus()
              }, 100)
            }
          }
        }

        return { addEvent, nextAba, firstAba }
      },
      showErrorList (errors) {
        const textSwal = `<ul>${errors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        const html = textSwal.replace(/\,/g,'')

        return this.displayError('HTML', html)
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao atualizar registro de nascimento'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
      bloquearRegistro (status) {
        this.save({
          codigo: status ? 30 : 10,
          dataAverb: null
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';
  @import '../../scss/_components/resumos';

  .headerTitle {
    @extend %titleBox--sm;
    background-color: $color-gray-light;

    &_error {
      color: #8B0000;
    }
  }

  .icon-error {
    width: 22px;
    height: 22px;
    margin: 0;
    padding: 0;
  }

  .label_error {
    color: #8B0000
  }

  .icon-error-campo {
    width: 15px;
    height: 15px;
    margin: 0;
    padding: 0;
    fill: #8B0000;
  }
  .headerEditNascimento{
    position: relative;
    right: 60px;
  }
</style>
